import React from "react";
import { ArrowRight, Check } from "lucide-react";
import { businessImage, polos } from "../mock";
import ProductCard from "./ProductCard";

export default function PolosSection() {
  const tags = ["Businesses", "Churches", "Ministries", "Teams", "Organizations", "Events"];
  const bullets = [
    "Left-chest logo, back print or both",
    "Mixed sizes across your order at no extra cost",
    "A proof to approve before anything is printed",
  ];

  return (
    <section id="polos" className="bg-[color:var(--dms-cream)] py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <div className="rounded-2xl overflow-hidden shadow-[0_20px_60px_-20px_rgba(20,36,61,0.35)]">
            <img src={businessImage} alt="Team in navy polos" className="w-full h-[560px] object-cover" />
          </div>
          <div>
            <p className="kicker">Polo Shirts</p>
            <h2 className="font-serif text-4xl md:text-5xl leading-tight mt-4 text-[color:var(--dms-navy)]">
              Professional apparel, built for your team
            </h2>
            <div className="w-14 h-[2px] bg-[color:var(--dms-peach)] mt-5" />
            <p className="mt-6 text-[color:var(--dms-navy)]/75 leading-relaxed">
              Professional apparel for everyday wear, businesses, churches, teams, organizations and events. Send us your logo and we'll put it on every shirt — clean, consistent, and the same on the hundredth polo as it was on the first.
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {tags.map((t) => (
                <span key={t} className="px-4 py-1.5 rounded-full border border-[color:var(--dms-navy)]/15 text-sm text-[color:var(--dms-navy)]">{t}</span>
              ))}
            </div>
            <ul className="mt-6 space-y-3">
              {bullets.map((b) => (
                <li key={b} className="flex items-start gap-3 text-[color:var(--dms-navy)]/85">
                  <span className="mt-1 w-5 h-5 rounded-full bg-[color:var(--dms-peach-light)]/60 flex items-center justify-center">
                    <Check className="w-3 h-3 text-[color:var(--dms-navy)]" />
                  </span>
                  <span>{b}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 flex flex-wrap gap-3">
              <a href="#custom" className="btn-navy">Customize your polos <ArrowRight className="w-4 h-4" /></a>
              <a href="#polos" className="btn-ghost-navy">Shop polos</a>
            </div>
          </div>
        </div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-6">
          {polos.map((p) => <ProductCard key={p.id} product={p} showPriceLabel />)}
        </div>
      </div>
    </section>
  );
}
